import React from "react";
import MyRouter from "routers/index";
import { LoadingProvider } from "./context/LoadingContext";

function App() {
  return (
    <LoadingProvider>
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
      
    </div>
    </LoadingProvider>
  );
}

export default App;
